import constants from './constants';

const updateMFAType = (mfa, type) => {
  mfa.type = type;
};

const updateMFAFlow = (mfa, flow) => {
  mfa.flow = flow;
};

const updateMFALogin = (mfa, login) => {
  mfa.login = login;
};

const updateMfaData = (state, mfaData) => {
  state.mfaData = {
    email: mfaData.email,
    phone: mfaData.phone
  };
  state.type = mfaData.mfaType;
  state.flow = mfaData.flow;
}

export default {
  [constants.MUTATION_UPDATE_MFA_TYPE]: updateMFAType,
  [constants.MUTATION_UPDATE_MFA_FLOW]: updateMFAFlow,
  [constants.MUTATION_UPDATE_MFA_LOGIN]: updateMFALogin,
  [constants.MUTATION_UPDATE_MFA_DATA]: updateMfaData
};



// WEBPACK FOOTER //
// ./src/store/modules/mfa/mutations.js